import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const DropDownFooter = ({
  isLoadingDropDownFooter,
  loadMore
}) => {
  if (isLoadingDropDownFooter) {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx("div", {
        className: "justify-center width-100",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          showResult: false,
          margin: "0"
        })
      })
    );
  }
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: () => loadMore(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "videoConference.settings.webinarsForm.select.textButtonLoadMore"
    })
  });
};